// Referral hierarchy, top → bottom. A logged-in user manages every role below their own.
export const REFERRAL_HIERARCHY = ["SuperAdmin", "ReferralAdmin", "Broker", "BDM", "SubBroker", "EndUser"];

// Roles allowed into the /referral dashboard (EndUser is the leaf, no dashboard)
export const REFERRAL_DASHBOARD_ROLES = REFERRAL_HIERARCHY.filter((r) => r !== "EndUser");

export const REFERRAL_ROLE_LABELS = {
  SuperAdmin: "Super Admin",
  ReferralAdmin: "Referral Admin",
  Broker: "Broker",
  BDM: "BDM",
  SubBroker: "Sub Broker",
  EndUser: "End User",
};

export const getLowerRoles = (role) => {
  const idx = REFERRAL_HIERARCHY.indexOf(role);
  return idx === -1 ? [] : REFERRAL_HIERARCHY.slice(idx + 1);
};
